export const disableVideo = (parentEl) => {
    const videoEl = parentEl.querySelector("video");
    const iFrameEl = parentEl.querySelector("iframe");

    if (videoEl) {
        videoEl.currentTime = 0;
        videoEl.pause();
    }

    if(iFrameEl) {
        const src = iFrameEl.src;
        const datasetSrc = iFrameEl.dataset.src;

        if(!datasetSrc)
            iFrameEl.dataset.src = src;

        iFrameEl.removeAttribute("src");
    }
}

export const enableVideo = (parentEl) => {
    const iFrameEl = parentEl.querySelector("iframe");

    if(!iFrameEl || !iFrameEl.dataset.src) return;

    iFrameEl.setAttribute("src", iFrameEl.dataset.src);
}